import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";

export class MascaraCnaePermitido extends BaseEntity {
	public id: number;
	public mascara: string;
	public tipoOperacao: string;
	public objetivoFinanciamento: string;
	public dataInicioValidade: Date;
	public dataFimValidade: Date;
	public dataEncerramento: Date;
	public justificativaEncerramento: string;
	public usuarioResponsavelEncerramento: string;
	public usuarioAtualizacao: string;
	public dataHoraAtualizacao: Date;
}